import { Action } from '@ngrx/store'
import { Product, ProductOrderHistory } from '../../core/models/product'
import { FilterToggleEvent } from '../../shared/models/filter';

import { RequestWrap } from '../../core/models/request-wrap'
import { FavoriteProduct } from '../models/favorite-product';

export const FILTER = '[Product] Filter'
export const FILTER_SUCCESS = '[Product] Filter Success'
export const FILTER_FAILED = '[Product] Filter Failed'

export const CLEAR_STATE = '[Product] Clear State'

export const GET_FAVORITES = '[Product] Get Favorites'
export const GET_FAVORITES_SUCCESS = '[Product] Get Favorites Success'
export const GET_FAVORITES_FAILED = '[Product] Get Favorites Failed'

export const ADD_FAVORITE = '[Product] Add Favorite'
export const ADD_FAVORITE_SUCCESS = '[Product] Add Favorite Success'
export const ADD_FAVORITE_FAILED = '[Product] Add Favorite Failed'

export const REMOVE_FAVORITE = '[Product] Remove Favorite'
export const REMOVE_FAVORITE_SUCCESS = '[Product] Remove Favorite Success'
export const REMOVE_FAVORITE_FAILED = '[Product] Remove Favorite Failed'

export const EXPAND = '[Product] Expand'
export const EXPAND_SUCCESS = '[Product] Expand Success'
export const EXPAND_FAILED = '[Product] Expand Failed'

export const SELECT = '[Product] Select'

export const GET_PRODUCT_HISTORY = '[Product] Get Product History'
export const GET_PRODUCT_HISTORY_SUCCESS = '[Product] Get Product History Success'
export const GET_PRODUCT_HISTORY_FAILED = '[Product] Get Product History Failed'

export const ADD = '[Product] Add'
export const ADD_SUCCESS = '[Product] Add Success'
export const ADD_FAILED = '[Product] Add Failed'

export const REMOVE = '[Product] Remove'

export const TOGGLE_INSTOCK = '[Product] Toggle In Stock'

export const SET_PRODUCT_FILTER = '[Product] Set Product Filter'
export const SET_PRODUCT_FILTER_SUCCESS = '[Product] Set Product Filter Success'
export const SET_PRODUCT_FILTER_FAILED = '[Product] Set Product Filter Failed'

export const SET_PRODUCT_DEFAULT_SORT_ORDER = '[Product] Set Product Default Sort Order'
export const SET_PRODUCT_DEFAULT_SORT_ORDER_SUCCESS = '[Product] Set Product Default Sort Order Success'
export const SET_PRODUCT_SORT_ORDER = '[Product] Set Product Sort Order'
export const SET_PRODUCT_SORT_ORDER_SUCCESS = '[Product] Set Product Sort Order Success'
export const SET_PRODUCT_SORT_ORDER_FAILED = '[Product] Set Product Sort Order Failed'

export class Filter implements Action {
    readonly type = FILTER
}
export class FilterSuccess implements Action {
    readonly type = FILTER_SUCCESS
    constructor(public payload: RequestWrap<Product[]>) {}
}
export class FilterFailed implements Action {
    readonly type = FILTER_FAILED
    constructor(public payload: any | null) { }
}
export class ClearState implements Action {
  readonly type = CLEAR_STATE
}

export class GetFavorites implements Action {
  readonly type = GET_FAVORITES
}
export class GetFavoritesSuccess implements Action {
  readonly type = GET_FAVORITES_SUCCESS
  constructor(public payload: FavoriteProduct[]) {}
}
export class GetFavoritesFailed implements Action {
  readonly type = GET_FAVORITES_FAILED
  constructor(public payload: any | null) { }
}

export class AddFavorite implements Action {
  readonly type = ADD_FAVORITE
  constructor(public payload: Product) {}
}
export class AddFavoriteSuccess implements Action {
  readonly type = ADD_FAVORITE_SUCCESS
  constructor(public payload: FavoriteProduct) {}
}
export class AddFavoriteFailed implements Action {
  readonly type = ADD_FAVORITE_FAILED
  constructor(public payload: any | null) {}
}
export class RemoveFavorite implements Action {
  readonly type = REMOVE_FAVORITE
  constructor(public payload: Product) {}
}
export class RemoveFavoriteSuccess implements Action {
  readonly type = REMOVE_FAVORITE_SUCCESS
  constructor(public payload: any | null) {}
}
export class RemoveFavoriteFailed implements Action {
  readonly type = REMOVE_FAVORITE_FAILED
  constructor(public payload: any | null) {}
}

export class Expand implements Action {
    readonly type = EXPAND
}
export class ExpandSuccess implements Action {
    readonly type = EXPAND_SUCCESS
    constructor(public payload: RequestWrap<Product[]>) {}
}
export class ExpandFailed implements Action {
    readonly type = EXPAND_FAILED
    constructor(public payload: any | null) {}
}

export class Select implements Action {
    readonly type = SELECT
    constructor(public payload: Product | string) {}
}

export class GetProductHistory implements Action {
  readonly type = GET_PRODUCT_HISTORY
  constructor(public payload: string) {}
}
export class GetProductHistorySuccess implements Action {
  readonly type = GET_PRODUCT_HISTORY_SUCCESS
  constructor(public payload: ProductOrderHistory[]) {}
}
export class GetProductHistoryFailed implements Action {
  readonly type = GET_PRODUCT_HISTORY_FAILED
  constructor(public payload?: string) {}
}

export class Remove implements Action {
    readonly type = REMOVE
    constructor(public payload: string) {}
}

export class Add implements Action {
  readonly type = ADD
  constructor(public payload: string) {}
}
export class AddSuccess implements Action {
  readonly type = ADD_SUCCESS
  constructor(public payload: Product) {}
}
export class AddFailed implements Action {
  readonly type = ADD_FAILED
  constructor(public payload: any) {}
}

export class ToggleInStock implements Action {
    readonly type = TOGGLE_INSTOCK
}

export class SetProductFilter implements Action {
  readonly type = SET_PRODUCT_FILTER
  constructor(public payload: FilterToggleEvent) {}
}
export class SetProductFilterSuccess implements Action {
  readonly type = SET_PRODUCT_FILTER_SUCCESS
}
export class SetProductFilterFailed implements Action {
  readonly type = SET_PRODUCT_FILTER_FAILED
}

export class SetProductDefaultSortOrder implements Action {
  readonly type = SET_PRODUCT_DEFAULT_SORT_ORDER
}
export class SetProductDefaultSortOrderSuccess implements Action {
  readonly type = SET_PRODUCT_DEFAULT_SORT_ORDER_SUCCESS
  constructor(public payload: string) {}
}
export class SetProductSortOrder implements Action {
  readonly type = SET_PRODUCT_SORT_ORDER
  constructor(public payload: string) {}
}
export class SetProductSortOrderSuccess implements Action {
  readonly type = SET_PRODUCT_SORT_ORDER_SUCCESS
}
export class SetProductSortOrderFailed implements Action {
  readonly type = SET_PRODUCT_SORT_ORDER_FAILED
}

export type Actions =
    Filter
    | FilterSuccess
    | FilterFailed
    | ClearState
    | GetFavorites
    | GetFavoritesSuccess
    | GetFavoritesFailed
    | AddFavorite
    | AddFavoriteSuccess
    | AddFavoriteFailed
    | RemoveFavorite
    | RemoveFavoriteSuccess
    | RemoveFavoriteFailed
    | Expand
    | ExpandSuccess
    | ExpandFailed
    | Select
    | GetProductHistory
    | GetProductHistorySuccess
    | GetProductHistoryFailed
    | Add
    | AddSuccess
    | AddFailed
    | Remove
    | ToggleInStock
    | SetProductFilter
    | SetProductFilterSuccess
    | SetProductFilterFailed
    | SetProductDefaultSortOrder
    | SetProductDefaultSortOrderSuccess
    | SetProductSortOrder
    | SetProductSortOrderSuccess
    | SetProductSortOrderFailed
